/*
 * Painting offer: which painting units get a discount stamp.
 *
 * Pure rule, no DOM and no network. The theme's stamping engine and the
 * builder app's order check both load this file, so they cannot drift apart.
 *
 *   computeStamps(arm, lines) -> { value, stamps: { [lineKey]: unitsToStamp } }
 *
 * Each input line: { key, quantity, price (unit price before discount),
 * stamped (optional boolean: the line carries a stamp now) }.
 *
 * Arm A, the one offer left since the test ended, stamps whole lines with
 * `20` (2 units) or `30` (3 or more units). `stamps[key]` is how many of that
 * line's units get the value. Every other line is absent from `stamps`.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.OmdOfferRule = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  var ARMS = ['A'];

  function countUnits(lines) {
    return lines.reduce(function (sum, line) { return sum + Math.max(0, Number(line.quantity) || 0); }, 0);
  }

  function computeStamps(arm, lines) {
    var total = countUnits(lines);
    var none = { value: '', stamps: {} };
    if (ARMS.indexOf(arm) === -1 || total < 2) return none;

    var value = total >= 3 ? '30' : '20';
    var whole = {};
    lines.forEach(function (line) { if (line.quantity > 0) whole[line.key] = line.quantity; });
    return { value: value, stamps: whole };
  }

  return { ARMS: ARMS, computeStamps: computeStamps };
});
